import * as React from 'react';
import { inject, injectable } from "inversify";
import { Button, notification, Form, Input, Icon } from 'antd';
import { observable, computed } from "mobx";
import { observer } from "mobx-react";
import autobind from 'autobind-decorator';

const FormItem = Form.Item;

interface InputWithRetypeViewProps {
    mode: ControlMode;
    onGetErrorMessage?: () => Promise<ValidationError[]>;
    label?: string;
    relabel?: string;
    type: 'password' | 'input';
    value1?: string | number;
    value2?: string | number;
    required?: boolean;
    onChange1?: (newValue: any) => void;
    onChange2?: (newValue: any) => void;
    addonBefore?: React.ReactNode;
    addonAfter?: React.ReactNode;
    addonClass?: string;
    prefix?: React.ReactNode;
    suffix?: React.ReactNode;
    description?: string;
    onClick?: (ev: React.MouseEvent<HTMLInputElement>) => void;
    style?: React.CSSProperties;
}

interface InputWithRetypeViewState {
    value1: any;
    value2: any;
    errors: ValidationError[];
}

@observer
export class InputWithRetypeView extends React.Component<InputWithRetypeViewProps, InputWithRetypeViewState>{

    constructor(props) {
        super(props);

        this.state = {
            value1: props.value1,
            value2: props.value2,
			errors:[]
        }
    }

    componentWillReceiveProps(nextProps: Readonly<InputWithRetypeViewProps>, nextContext: any) {
        if (this.props.value1 != nextProps.value1 || this.props.value2 != nextProps.value2) {
            this.setState({
                value1: nextProps.value1,
                value2: nextProps.value2
            });
        }
    }

	@autobind
    protected async onChange1(newVal:any) {
        newVal = newVal.target.value;
        this.props.onChange1(newVal);
        if (this.props.onGetErrorMessage != null) {
            const errors = await this.props.onGetErrorMessage();
            this.setState({
                value1: newVal,
                errors: errors
            });
        } else {
            this.setState({
                value1: newVal,
            });
        }
    }
    @autobind
    protected async onChange2(newVal: any) {
        newVal = newVal.target.value;
        this.props.onChange2(newVal)
        if (this.props.onGetErrorMessage != null) {
            const errors = await this.props.onGetErrorMessage();
            this.setState({
                value2: newVal,
                errors: errors
            });
        } else {
            this.setState({
                value2: newVal,
            });
        }
    }

    render() {
        return <div>
            <FormItem label={this.props.label}
                required={this.props.required}
                validateStatus={this.state.value1 == this.state.value2 ? 'success' : 'error'}
            className={this.props.addonClass}
            help={this.props.description}>
            <Input
                type={this.props.type}
                prefix={this.props.prefix != null ? this.props.prefix : null}
                suffix={this.props.suffix != null ? this.props.suffix : null}
                addonBefore={this.props.addonBefore != null ? this.props.addonBefore : null}
                addonAfter={this.props.addonAfter != null ? this.props.addonAfter : null}
                onChange={this.onChange1}
                placeholder={this.props.label}
                value={this.state.value1}
                onClick={this.props.onClick}
                disabled={this.props.mode == 'display'}
                style={this.props.style}
            />
            </FormItem>
            <FormItem label={this.props.relabel}
                required={this.props.required}
                validateStatus={this.state.value1 == this.state.value2 ? 'success' : 'error'}
                className={this.props.addonClass}
                help={this.props.description}>
                <Input
                    type={this.props.type}
                    prefix={this.props.prefix != null ? this.props.prefix : null}
                    suffix={this.props.suffix != null ? this.props.suffix : null}
                    addonBefore={this.props.addonBefore != null ? this.props.addonBefore : null}
                    addonAfter={this.props.addonAfter != null ? this.props.addonAfter : null}
                    onChange={this.onChange2}
                    placeholder={this.props.relabel}
                    value={this.state.value2}
                    onClick={this.props.onClick}
                    disabled={this.props.mode == 'display'}
                    style={this.props.style}
                />
            </FormItem>
			</div>
			;
    }

}


// WEBPACK FOOTER //
// ./src/core/ui/password-creation.tsx